import { render, staticRenderFns } from "./item-radio.vue?vue&type=template&id=c7d9d352&scoped=true"
import script from "./item-radio.vue?vue&type=script&setup=true&lang=js"
export * from "./item-radio.vue?vue&type=script&setup=true&lang=js"
import style0 from "./item-radio.vue?vue&type=style&index=0&id=c7d9d352&prod&lang=less&scoped=true"
import style1 from "./item-radio.vue?vue&type=style&index=1&id=c7d9d352&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7d9d352",
  null
  
)

export default component.exports